<template>
    <ul :class="['toggle-theme-' + this.theme]">
        <li v-for="option in options" :class="getOptionClasses(option)" @click="$emit('input', option)">
            {{ option.label }}
            <span v-if="option.count && option.count > 0" class="toggle-badge">{{ option.count }}</span>
        </li>
    </ul>
</template>

<script>
    export default {
        props: {
            theme: {
                type: String,
                default: 'default'
            },
            options: {
                type: Array,
                required: true
            },
            value: {
                type: [String,Number],
            }
        },
        methods: {
            getOptionClasses(option) {
                let classes = []

                if (option.value === this.value) {
                    classes.push('selected')
                }

                return classes
            }
        }
    }
</script>

<style lang="scss" scoped>
    ul {
        list-style: none;
        margin: 0; padding: 0;
        li {
            position: relative;
            padding: .15rem .5rem;
            border-radius: 5px;
            background: #f8f8f8;
            display: inline-block;
            margin-right: .25rem;
            font-weight: bold;
            cursor: pointer;
            color: #999;
            &:hover {
                background: #efefef;
            }

            &.selected {
                background: #2196f3;
                color: white;
            }
        }

        &.toggle-theme-table-header {
            display: inline-block;
            background: rgb(0 0 0 / 5%);
            //background: #f2f3f5;
            padding: 4px 4px;
            vertical-align: middle;
            font-size: .75em;
            border-radius: 5px;

            margin-right: 1rem;

            .toggle-badge {
                font-size: 10px;
                display: inline-block;
                padding: 0px 4px;
                border-radius: 3px;
                color: #fff;
                opacity: 1 !important;
                background: #999;
                vertical-align: middle;
                margin-bottom: 2px;
            }

            li {
                font-size: .9rem;
                background: transparent;
                padding: 0.15rem 1rem;
                 &:hover {
                    background: #ffffff;
                }

                &.selected {
                    //background: #2196f3;
                    //color: white;
                    background: rgb(0 0 0 / 6%);
                    color: #2196f3;

                    .toggle-badge {
                        background: #bc0101;
                    }
                }
            }
        }
    }
</style>